export default "__VITE_ASSET__D569Zs6f__"